import * as React from 'react'

import { Box, Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

interface Props {
  form: SurveyForm | Survey
}

function AnswersAvailability({ form: surveyForm }: Props) {
  const disabled = !surveyForm.isDraft

  const form = React.useRef(
    new Form(surveyForm.toJS(), {
      visible_to_managers: 'boolean',
    })
  ).current

  const onToggleVisibility = () => {
    form.setValues({
      visible_to_managers: !form.get('visible_to_managers').value,
    })
    submit()
  }

  const { performAction: submit } = useAsyncAction(() => form.save(surveyForm))

  return (
    <Section
      illustration="handing-paper"
      title={i18n.t('surveys.form.answers_availability.title')}
      description={i18n.t('surveys.form.answers_availability.description')}
    >
      <Box gap="s16" aria-label="Here you find the visibility settings for the answers">
        <Card>
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                value={form.get('visible_to_managers').value}
                onChange={onToggleVisibility}
                disabled={disabled}
              />
            }
          >
            {i18n.t(
              'surveys.form.answers_availability.form.labels.show_results_to_managers_and_team_leads'
            )}
          </Card.Title>
          <Card.Description>
            {i18n.t(
              'surveys.form.answers_availability.show_results_to_managers_and_team_leads.subtitle'
            )}
          </Card.Description>
        </Card>
      </Box>
    </Section>
  )
}

export default observer(AnswersAvailability)
